import apiRequestService from '@/commonProject/service/apiRequestService';

export default class AgreementRepository {
    /**
     * ユーザー同意済規定一覧取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getAgreementListApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/usrreglst', requestBody, idToken);
        return result;
    }
    /**
     * 規定詳細取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getAgreementDetailApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/regdtl', requestBody, idToken);
        return result;
    }
}
